import type { FunctionComponent, PropsWithChildren } from "react"

import { clsx } from "clsx"

import { Text } from "@jobteaser/spark/components/Text"
import { Icon, ICON_SIZES } from "@jobteaser/ui-kit/dist/module/components/Icon/Icon"

import styles from "./KeyInformation.module.css"

type KeyInformationProps = {
  className?: string
  colorReverse?: boolean
  icon?: SVGElement
  noSpacing?: boolean
  title: string
}

export const KeyInformation: FunctionComponent<PropsWithChildren<KeyInformationProps>> = ({
  children,
  className,
  colorReverse,
  icon,
  noSpacing,
  title,
}) => (
  <div
    className={clsx([
      styles.keyInformation,
      {
        [styles["keyInformation--colorReverse"]]: colorReverse,
        [styles["keyInformation--noSpacing"]]: noSpacing,
        [styles["keyInformation--withIcon"]]: icon,
      },
      className,
    ])}
    data-testid="company_key_information"
  >
    {icon && (
      <figure className={styles.keyInformation__icon} data-testid="company_key_information_icon">
        <Icon role="graphics-symbol" size={ICON_SIZES.BIG} xlinkHref={`#${icon.id}`} />
      </figure>
    )}
    <div data-testid="company_key_information_content">
      <Text data-testid="company_key_information_title" variant="body2" weight="regular">
        {title}
      </Text>
      {children}
    </div>
  </div>
)
